import React from 'react';

const BooleanCell = ({flag, field}) => {

	if(flag) {
		return <div role="gridcell" aria-label={field + " checked"} style={{ width: "calc(100% - 18px)" }} className={"fa-fw fa-ok"}></div>;
	} else {
		return <div role="gridcell" aria-label={field + " not checked"} style={{ width: "calc(100% - 18px)" }} ></div>;
	}	
}

export default BooleanCell;